import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[dtypeItemHost]',
    standalone: false
})
export class DtypeDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}
